import React from "react";
import { BsSearch } from "react-icons/bs";

const OffCanvasButton = ({ label, textColor, bgColor, icon, font, activeCount = 0, target }) => {
    return (
        <div className="d-flex align-items-center gap-2">
            {/* Botón principal con filtro */}
            <button
                type="button"
                className="btn btn-gray filterbtn d-flex align-items-center gap-1 position-relative"
                data-bs-toggle="offcanvas"
                data-bs-target={target}
                aria-controls={target?.replace("#", "")}
            >
                <div className="filter_text d-flex align-items-center gap-1">
                    <span className="d-block material-symbols-outlined icon-md">tune</span>
                    <span className="d-block">Filter</span>
                </div>
                
                {/* Show badge only if there are active filters */}
                {activeCount > 0 && (
                    <span 
                        className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary" 
                        style={{fontSize: '0.6rem', padding: '0.2rem 0.4rem'}}
                    >
                        {activeCount}
                    </span>
                )}
            </button>
        </div>
    );
};

export default OffCanvasButton;